import { namespace } from 'vuex-class';
import { IEntityState } from './entity.types';

export const entityNamespace = 'entity';
export const Entity = namespace(entityNamespace);

export function getDefaultState(): IEntityState {
  return {
    entityId: '',
    isLoading: false,
    users: [],
    teams: [],
    isLoadingTeams: false,
    planStatus: undefined,
    entity: {
      logoUrl: '',
      theme: {
        name: '',
        accentColor: '',
        backgroundColor: '',
        backgroundImage: '',
        signButtonText: '',
      },
    },
    entities: null,
  };
}

export enum EEntityAction {
  LoadEntitySettings = 'loadEntitySettings',
  ChangePassword = 'changePassword',

  LoadUsers = 'loadUsers',
  LoadUsersSuccess = 'loadUsersSuccess',

  LoadTeams = 'loadTeams',
  LoadTeamsSuccess = 'loadTeamsSuccess',
  LoadTeamsFailed = 'loadTeamsFailed',

  SetIsLoadingTeams = 'setIsLoadingTeams',

  LoadPlanStatus = 'loadPlanStatus',
  LoadPlanStatusSuccess = 'loadPlanStatusSuccess',
  LoadPlanStatusFailed = 'loadPlanStatusFailed',

  LoadEntity = 'loadEntity',
  LoadEntitySuccess = 'loadEntitySuccess',

  LoadEntities = 'loadEntities',
  LoadEntitiesSuccess = 'loadEntitiesSuccess',
  LoadEntitiesFailed = 'loadEntitiesFailed',

  SelectEntity = 'selectEntity',
  SelectEntitySuccess = 'selectEntitySuccess',
  SelectEntityFailed = 'selectEntityFailed',

  AuthEntity = 'authEntity',
}

export enum EEntityMutation {
  SetIsLoading = 'setIsLoading',
  SetEntitySettings = 'setEntitySettings',
  SetUsers = 'setUsers',
  SetTeams = 'setTeams',
  SetIsLoadingTeams = 'setIsLoadingTeams',
  SetPlanStatus = 'setPlanStatus',
  SetEntity = 'setEntity',
  SetEntities = 'setEntities',
}
